import club from './club/club-module';
import team from './team/team-module';
import category from './category/category-module';
import player from './player/player-module';
import manager from './manager/manager-module';
import position from './position/position-module';
import routes from './entities-routes';
import EntityLink from './entity-link';
import coach from './coach/coach-module';
import teamManager from './team-manager/team-manager-module';
import document from './document/document-module';
import fieldManager from './field-manager/field-manager-module';
import referee from './referee/referee-module';
import tournament from './tournament/tournament-module';

const entities = [
  club,
  team,
  category,
  player,
  manager,
  position,
  coach,
  teamManager,
  document,
  fieldManager,
  referee,
  tournament
];

const extractFromEntities = (property) =>
  entities
    .map((entity) => entity[property] || [])
    .reduce((a, b) => a.concat(b), []);

export default {
  components: [
    EntityLink,
    ...extractFromEntities('components')
  ],
  mixins: [...extractFromEntities('mixins')],
  filters: [...extractFromEntities('filters')],
  directives: [...extractFromEntities('directives')],
  routes,
  store: {
    namespaced: true,

    modules: {
      club: club.store,
      team: team.store,
      category: category.store,
      player: player.store,
      manager: manager.store,
      position: position.store,
      coach: coach.store,
      "team-manager": teamManager.store,
      document: document.store,
      fieldManager: fieldManager.store,
      referee: referee.store,
      tournament: tournament.store
    }
  }
};



// WEBPACK FOOTER //
// ./src/entities/entities-module.js